module.exports = __webpack_public_path__ + "static/media/etr.429d854e.svg";